import { useNavigate } from "../router";

export const Services = (props) => {
  const navigate = useNavigate();

  const openDetailPage = (service) => {
    if (!service?.slug) return;
    navigate(`/service/${service.slug}`, { state: { item: service } });
  };

  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Services</h2>
        </div>
        <div className='service-grid'>
          {props.data
            ? props.data.map((d, i) => (
                d.image ? (
                  <div
                    key={`${d.name}-${i}`}
                    className='panel service-card hero-card'
                    role="button"
                    tabIndex={0}
                    onClick={() => openDetailPage(d)}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openDetailPage(d)}
                  >
                    <div
                      className='service-hero'
                      style={{ backgroundImage: `url(${d.image})` }}
                      aria-label={d.name}
                      data-align={d.overlayAlign === "left" ? "left" : "right"}
                    >
                      <div className='service-hero-overlay'>
                        <h3>{d.name}</h3>
                        <p>{d.text}</p>
                        <span className="service-cta">Learn More →</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    key={`${d.name}-${i}`}
                    className='panel service-card'
                    role="button"
                    tabIndex={0}
                    onClick={() => openDetailPage(d)}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openDetailPage(d)}
                  >
                    <div className='icon-wrap'>
                      <i className={d.icon}></i>
                    </div>
                    <div className='service-desc'>
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                )
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
